export enum FormTemplateCategoryEnum {
  PAIS = 1,
  ISQ = 2,
  CFET = 3,
  SA = 4,
}
